import React, { useEffect } from "react";
import { showToast, Timeline } from "../../../../../components";
import { dateFormator } from "../../../../../utils";

const Activities = ({ activities }) => {
  useEffect(() => {
    if (Array.isArray(activities) && activities.length === 0) {
      showToast("No activities found.", "error");
    }
  }, [])
  return (
    <div className="flex-1 py-5 rounded-xl shadow-xl inner-section px-6 overflow-hidden">
      <div className="flex justify-between p-3">
        <h6>Timeline</h6>
        <p className="text-sm font-semibold text-gray-400 ">
          From ({dateFormator(activities?.[activities.length - 1]?.taskDate, "full")}) To ({dateFormator(activities?.[0]?.taskDate, "full")})
        </p>
      </div>
      <Timeline
        data={activities}
      />
    </div>
  );
};

export default Activities;
